export default "__VITE_ASSET__CMihPyuE__"